import { axiosInstance } from "@src/api/axiosConfig";
import { axiosPath } from "@src/api/axiosPath";
import { SearchListRequestDto } from "./dto/SearchList.dto";

export const usePrevDeungi = async (pin: string) => {
    const response = await axiosInstance.get(`${axiosPath.prevDeungi}/${pin || ''}`);
    return response;
};
